import { Navigate, Outlet } from 'react-router-dom';
import { APP_ROUTES } from './appRoutes.js';
import {getToken} from '../features/auth/authHelpers.js';

const ProtectedRoute = () => {
    const isAuthenticated = Boolean(getToken());
    return isAuthenticated ? <Outlet /> : <Navigate to={APP_ROUTES.LOGIN} />;
};

export default ProtectedRoute;
